export default class BubblePositionCalculator {

    static calculatePosition(event) {
        let target = event.target;
        if(target.length) {
            target = target[0];
        }

        let position = {
            width: 364
        };

        position.originX = target.documentOffsetLeft + target.offsetWidth/2;
        position.originY = target.documentOffsetTop + target.offsetHeight;

        position.top = position.originY + 35;

        position.left = position.originX - (position.width/2);
        position.overflow = (position.left + position.width) - (window.innerWidth - 20);

        if(position.overflow > 0) {
            position.left -= position.overflow;
        } else {
            position.overflow = 0;
        }

        if(position.left < 0) {
            position.overflow += (position.left - 20);
            position.left = 20;
        }

        return position;
    }
}


/** WEBPACK FOOTER **
 ** ./src/logic/bubble-position-calculator.js
 **/